var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import VueDialog from "../../interface/IVueDialog";
import SupplierService from "../../api/SupplierService";
import GoodService from "../../api/GoodService";
import { Loading } from 'element-ui';
var SetDefaultSupplierDialog = (function (_super) {
    __extends(SetDefaultSupplierDialog, _super);
    function SetDefaultSupplierDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.supplierupperOptions = [];
        _this.selectRows = [];
        return _this;
    }
    SetDefaultSupplierDialog.prototype.created = function () {
        this.service = GoodService.getInstance();
        this.supplierService = SupplierService.getInstance();
        this.getSupplierupperOptions();
    };
    SetDefaultSupplierDialog.prototype.getSupplierupperOptions = function (val) {
        var _this = this;
        var params = {
            keyword: val || ''
        };
        this.supplierService.getSupplierupperOptions(params).then(function (res) {
            if (res.data.success) {
                var data = res.data.data || [];
                data.unshift({
                    supplier_upper_id: 0,
                    supplier_upper_name: "请选择"
                });
                _this.supplierupperOptions = data;
            }
        });
    };
    SetDefaultSupplierDialog.prototype.filterSearch = function (val) {
        var _this = this;
        clearTimeout(this.time);
        this.time = setTimeout(function () {
            _this.getSupplierupperOptions(val);
        }, 500);
    };
    SetDefaultSupplierDialog.prototype.close = function () {
        this.$closeDialog();
    };
    SetDefaultSupplierDialog.prototype.submitData = function () {
        var _this = this;
        var confirmMsg = '';
        if (this.selectRows.length == 1) {
            if (this.selectRows[0].supplier_upper_name)
                confirmMsg = "\u68C0\u6D4B\u5230\u5F53\u524D\u8D27\u54C1\u5DF2\u8BBE\u7F6E\u9ED8\u8BA4\u4F9B\u5E94\u5546\u201C" + this.selectRows[0].supplier_upper_name + "\u201D\uFF0C\u8BF7\u786E\u8BA4\u662F\u5426\u66F4\u6362";
        }
        else {
            var conditionArr = this.selectRows.filter(function (v) { return v.supplier_upper_name; });
            if (conditionArr.length)
                confirmMsg = "\u201C\u68C0\u6D4B\u5230\u6240\u9009\u8D27\u54C1\u4E2D\u6709" + (conditionArr.length + 1) + "\u4E2A\u5DF2\u7ECF\u8BBE\u7F6E\u9ED8\u8BA4\u4F9B\u5E94\u5546\uFF0C\u8BF7\u786E\u8BA4\u662F\u5426\u66F4\u6362";
        }
        if (confirmMsg) {
            this.$confirm(confirmMsg, '提示', {
                customClass: 'confirm'
            }).then(function (res) {
                if (res) {
                    _this.setSupplierUpper();
                }
            }).catch(function (err) {
                console.log(err);
            });
        }
        else {
            this.setSupplierUpper();
        }
    };
    SetDefaultSupplierDialog.prototype.setSupplierUpper = function () {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.setSupplierUpper({
            goods_ids: this.goodId,
            supplier_upper_id: this.supplier_upper_id || ''
        }).then(function (res) {
            loadingInstance.close();
            _this.$message.success(res.data.msg);
            _this.$emit('setDefaultSupplier');
            _this.close();
        }, function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    SetDefaultSupplierDialog = __decorate([
        Component
    ], SetDefaultSupplierDialog);
    return SetDefaultSupplierDialog;
}(VueDialog));
export default SetDefaultSupplierDialog;
